import { BoilerCommand, BoilerCommandAutomate, BoilerCommandMan, BoilerState } from "@eisox/api/core-api";

import { m } from "~/paraglide/messages";

export const shouldDisplayBoilerCommutator = (
  state?: BoilerState,
  commandAutomate?: BoilerCommandAutomate,
  commandMan?: BoilerCommandMan,
  command?: BoilerCommand,
): boolean => {
  if (
    (state !== undefined &&
      commandAutomate !== undefined &&
      commandMan === BoilerCommandMan.MANUAL &&
      command !== undefined) ||
    (state === undefined &&
      commandAutomate !== undefined &&
      commandMan === BoilerCommandMan.MANUAL &&
      command !== undefined) ||
    (state === undefined &&
      commandAutomate === undefined &&
      commandMan === BoilerCommandMan.MANUAL &&
      command !== undefined)
  ) {
    return true;
  }
  return false;
};

export const isBoilerAutoManualOrForcing = (
  command?: BoilerCommand,
  commandMan?: BoilerCommandMan,
): "auto" | "manual" | "forcing" => {
  if (commandMan === BoilerCommandMan.MANUAL) return "manual";
  if (command === BoilerCommand.FAST || command === BoilerCommand.NORMAL || command === BoilerCommand.OFF)
    return "forcing";
  return "auto";
};

export const getBoilerState = (
  state?: BoilerState,
  commandAutomate?: BoilerCommandAutomate,
  commandMan?: BoilerCommandMan,
  defect?: boolean,
): { state: BoilerState | BoilerCommandAutomate | null; error?: string } => {
  if (defect) return { state: null };
  if (commandMan === BoilerCommandMan.MANUAL) {
    if (state !== undefined) {
      return { state: state };
    }
    return {
      state: null,
      error: m.boiler_warning_1(),
    };
  }
  if (state !== undefined) {
    return {
      state: state,
      error: commandMan === undefined ? m.boiler_warning_3() : undefined,
    };
  }
  if (commandAutomate !== undefined) {
    return {
      state: commandAutomate,
      error: commandMan === undefined ? m.boiler_warning_4() : m.boiler_warning_2(),
    };
  }
  return {
    state: null,
    error: m.boiler_warning_5(),
  };
};
